<div class="ghost"></div>
<div class="header mobile-header-only">
  <div class="wrapper-home" (click)="goToZilex()">

    <div class="placeholder"></div>

  </div>
  <app-header></app-header>
  <app-language-menu (onLanguageChange)="vmOnLanguageChange($event)"></app-language-menu>
</div>
<div class="main-container">

  <div class="header desktop-header-only">
    <div class="wrapper-home">
      <div class="icon-wrapper">
        <div class="placeholder"></div>
      </div>
      <div class="text">
        zilex.de
      </div>
    </div>
    <app-header></app-header>
    <app-language-menu></app-language-menu>
  </div>
  <div class="wrapper-main">
    <div class="wrapper-right">
      <form class="settings-form" *ngIf="!forgotPasswordFormSubmited">

        <div class="title">{{'forgotPasswordPage.title' | translate}}</div>
        <div class="field">
          <label for="email">{{'forgotPasswordPage.email' | translate}}:</label>
          <input type="email" name="email" id="email" [(ngModel)]="email" patterns="^[^\s@]+@[^\s@]+\.[^\s@]+$"
            required>
        </div>

        <div class="buttons-block">
          <button class="btn" (click)="cancel($event);">{{'forgotPasswordPage.cancelButton' | translate}}</button>
          <button type="submit" class="btn btn-green" (click)="submitForgotPassword($event)">OK</button>
        </div>


        <div class="forgot-password-validation-errors">
          <div class="msg" *ngIf="emailNotValid">{{'registration.form.validationMsg.emailNotValid'|translate}}
          </div>
        </div>
      </form>
      <div class="msg" *ngIf="forgotPasswordFormSubmited">{{'forgotPasswordPage.confirmMessage' |
        translate}}</div>
    </div>
  </div>
</div>